export default __webpack_public_path__ + "static/media/packingForTravel.462edcd9.md";